import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
    {
        path: "/:country([a-z][a-z])?", // matches two digits for country code (us / es/ pa) and is optional
        component: {
            render: h => h("router-view")
        },
        children: [
            {
                path: "",
                name: "home",
                component: Home
            },
            {
                path: "series",
                name: "series",
                component: () =>
                    import(
                        /* webpackChunkName: "series" */ "../views/Series.vue"
                    ),
                meta: { hideNavigationGlow: true }
            },
            {
                path: "series/:id",
                name: "serie",
                component: () =>
                    import(/* webpackChunkName: "serie" */ "../views/Serie.vue")
            },
            {
                path: "player",
                name: "player",
                component: () =>
                    import(
                        /* webpackChunkName: "player" */ "../views/Player.vue"
                    ),
                meta: {
                    hideNavigation: true,
                    hideNavigationGlow: true,
                    hideFooter: true
                }
            },
            {
                path: "games",
                name: "games",
                component: () =>
                    import(
                        /* webpackChunkName: "games" */ "../views/Games.vue"
                    ),
                meta: { hideNavigationGlow: true }
            },
            {
                path: "games/:id",
                name: "game",
                component: () =>
                    import(/* webpackChunkName: "game" */ "../views/Game.vue")
            },
            {
                path: "login",
                name: "login",
                component: () =>
                    import(/* webpackChunkName: "login" */ "../views/Login.vue")
            },
            {
                path: "register/select-plan",
                name: "register-select-plan",
                component: () =>
                    import(
                        /* webpackChunkName: "register-select-plan" */ "../views/register/SelectPlan.vue"
                    )
            },
            {
                path: "register/sign-up",
                name: "register-sign-up",
                component: () =>
                    import(
                        /* webpackChunkName: "register-sign-up" */ "../views/register/SignUp.vue"
                    )
            },
            {
                path: "register/payment",
                name: "register-payment",
                component: () =>
                    import(
                        /* webpackChunkName: "register-payment" */ "../views/register/Payment.vue"
                    )
            },
            {
                path: "not-logged",
                name: "not-logged",
                component: () =>
                    import(
                        /* webpackChunkName: "not-logged" */ "../views/NotLogged.vue"
                    )
            },
            {
                path: "forgot-password",
                name: "forgot-password",
                component: () =>
                    import(
                        /* webpackChunkName: "forgot-password" */ "../views/ForgotPassword.vue"
                    ),
                meta: { hideNavigation: true }
            },
            {
                path: "reset-password",
                name: "reset-password",
                component: () =>
                    import(
                        /* webpackChunkName: "reset-password" */ "../views/ResetPassword.vue"
                    ),
                meta: { hideNavigation: true }
            },
            {
                path: "preferences",
                name: "preferences",
                component: () =>
                    import(
                        /* webpackChunkName: "preferences" */ "../views/Preferences.vue"
                    ),
                meta: { hideNavigationGlow: true }
            },
            {
                path: "preferences/:field",
                name: "preference",
                component: () =>
                    import(
                        /* webpackChunkName: "preference" */ "../views/Preference.vue"
                    ),
                meta: { hideNavigationGlow: true }
            },
            {
                path: "about",
                name: "about",
                meta: { unlock: true },
                component: () =>
                    import(/* webpackChunkName: "about" */ "../views/About.vue")
            },
            {
                path: "contact",
                name: "contact",
                component: () =>
                    import(
                        /* webpackChunkName: "contact" */ "../views/Contact.vue"
                    ),
                meta: { hideNavigation: true, unlock: true }
            },
            {
                path: "privacy-policy",
                name: "privacy-policy",
                meta: { unlock: true },
                component: () =>
                    import(
                        /* webpackChunkName: "privacy-policy" */ "../views/PrivacyPolicy.vue"
                    )
            },
            {
                path: "terms-of-use",
                name: "terms-of-use",
                meta: { unlock: true },
                component: () =>
                    import(
                        /* webpackChunkName: "terms-of-use" */ "../views/TermsOfUse.vue"
                    )
            }
        ]
    },
    {
        path: "/region-lock",
        name: "region-lock",
        component: () =>
            import(
                /* webpackChunkName: "region-lock" */ "../views/RegionLock.vue"
            ),
        meta: { hideNavigation: true }
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,

    routes,

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {

    console.log("passing before", to)
    let { region } = store.state;

    if (!region) {
        // if there's not region, we must be on the app first load
        // so the App.vue component will handle redirects in this case
        next();
    } else {
        let countryCode = region.data.code;

        if (to.meta.unlock) {
            console.log("unlock this", to);
            next();
        } else  if (
            region.status === "false" &&
            to.name !== "region-lock"
        ) {
            console.log("lock this", to.name, countryCode);

            next({ name: "region-lock" });
        } else if (!to.params.country || to.params.country !== countryCode) {
            to.params.country = countryCode;

            next(to);
        } else {
            next();
        }


    }
});

export default router;
